import { render, staticRenderFns } from "./CustomIframe.vue?vue&type=template&id=43d879d6&scoped=true&"
import script from "./CustomIframe.vue?vue&type=script&lang=js&"
export * from "./CustomIframe.vue?vue&type=script&lang=js&"
import style0 from "./CustomIframe.vue?vue&type=style&index=0&id=43d879d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d879d6",
  null
  
)

export default component.exports